import React from 'react';
import type { ICellRendererParams } from 'ag-grid-community';
import { Observations } from '../../../components/review-data';
import type { ReviewCellRendererProps } from '../helpers';
import { useColorTheme } from 'venn-ui-kit';

export const SparklineCellRenderer = ({ additionalMetadata, data }: ICellRendererParams & ReviewCellRendererProps) => {
  const { cumulativeReturn, startOfNewData, newDataCount, seriesId, fundId } = data;
  const { colors } = useColorTheme();
  const { isDisabled } = additionalMetadata.perSeries[seriesId]!;

  const delimiter =
    startOfNewData === null
      ? cumulativeReturn.length
      : cumulativeReturn.findIndex((returns: number[]) => returns[0]! >= startOfNewData);
  const dataPoints = cumulativeReturn.map((returns: number[]) => ({ x: returns[0]!, y: returns[1]! }));

  return (
    <Observations
      className={isDisabled ? 'opacity-25' : undefined}
      data={dataPoints.slice(delimiter)}
      newDataColor={fundId ? colors.Black : undefined}
      newDataCount={newDataCount}
      previousData={delimiter > 0 ? dataPoints.slice(0, delimiter + 1) : undefined}
    />
  );
};
